/**
 * Forgot Password Component
 */

import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authAPI, partnerAPI, settingsAPI } from '../services/api';
import './Login.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const istPartner = new URLSearchParams(location.search).get('bereich') === 'partner';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [headerTitle, setHeaderTitle] = useState('Der Starke Franz');

  useEffect(() => {
    settingsAPI.getPublicSettings().then(res => {
      if (res.data?.header_title) setHeaderTitle(res.data.header_title);
    }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await (istPartner ? partnerAPI : authAPI).forgotPassword(email);
      navigate(istPartner ? '/reset-password?bereich=partner' : '/reset-password', { state: { email } });
    } catch (err) {
      setError(err.response?.data?.error || 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.');
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>{headerTitle}</h1>
        <h2>Passwort zurücksetzen</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-Mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="deine@email.com"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading}>
            {loading ? 'Wird gesendet...' : 'Code senden'}
          </button>

          <Link to={istPartner ? '/login?bereich=partner' : '/login'} style={{ display: 'block', textAlign: 'center', color: '#c87a3e', fontWeight: '600', fontSize: '14px', marginTop: '20px' }}>
            Zurück zum Login
          </Link>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
